import { render, staticRenderFns } from "./PropertyTrademark.vue?vue&type=template&id=015f4cd4&scoped=true&"
import script from "./PropertyTrademark.vue?vue&type=script&lang=js&"
export * from "./PropertyTrademark.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTrademark.vue?vue&type=style&index=0&id=015f4cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f4cd4",
  null
  
)

export default component.exports